module.exports = __webpack_public_path__ + "static/img/0013-A-01.aa6d33e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audioimg/0013-A-01.jpg
// module id = Ecou
// module chunks = 0